import axiosInstance from './AxiosInstance';

const DashboardService = {
	getSummaryStats: async (companyId = null, branchId = null) => {
		try {
			const params = {};
			if (companyId) params.companyId = companyId;
			if (branchId) params.branchId = branchId;
			const response = await axiosInstance.get('/dashboard/summary', { params });
			return {
				success: response.data.success,
				data: response.data.data,
				message: response.data.message || 'Summary stats fetched successfully'
			};
		} catch (error) {
			return {
				success: false,
				message: error.response?.data?.message || 'Failed to fetch summary stats',
				errors: error.response?.data?.errors || []
			};
		}
	},
	getChartData: async (period = 'month', companyId = null, branchId = null) => {
		try {
			const params = {};
			if (companyId) params.companyId = companyId;
			if (branchId) params.branchId = branchId;
			const endpoint = `/dashboard/chart/${period.toLowerCase()}`;
			const response = await axiosInstance.get(endpoint, { params });
			return {
				success: response.data.success,
				data: response.data.data,
				message: response.data.message || 'Chart data fetched successfully'
			};
		} catch (error) {
			return {
				success: false,
				message: error.response?.data?.message || 'Failed to fetch chart data',
				errors: error.response?.data?.errors || []
			};
		}
	}
};

export default DashboardService;
